module.exports = __webpack_public_path__ + "img/advice1.db3ca060.png";